import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useEtsyMarketplaceStore = defineStore('etsyMarketplace', () => {
  const loading = ref(false);
  const connectShop = async (marketplace: string, shop: string) => {
    window.location.href = `/account/connect-shop/${marketplace}/${shop}`;
  };

  return {
    connectShop,
    loading,
  };
});
